<template>
  <div>
    <label :for="`json-${_uid}`">Meta-Daten</label>
    <div ref="editor"></div>
  </div>

</template>

<script>
import JSONEditor from 'jsoneditor';

export default {
  name: 'JsonEditor',

  props: {
    metaInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      editor: null,
      initialSet: false,
    };
  },

  mounted() {
    this.editor = new JSONEditor(this.$refs.editor, {
      mode: 'code',
      onChangeText: this.onChangeText,
    });

    this.editor.set(this.metaInfo);
  },

  beforeDestroy() {
    this.editor.destroy();
  },

  watch: {
    metaInfo(newVal, oldVal) {
      if (newVal !== oldVal && this.editor && !this.initialSet) {
        this.editor.set(newVal);
        this.initialSet = true;
      }
    },
  },

  methods: {
    onChangeText(jsonString) {
      try {
        this.$emit('json-editor:set-json', JSON.parse(jsonString));
        this.$emit('json-editor:set-json-validation', true);
        this.initialSet = true;
      } catch (err) {
        this.$emit('json-editor:set-json-validation', false);
      }
    },
  },
};
</script>
